{
  "post_payment": {
    "step_1_title": "Först behöver vi lite info om dig",
    "step_1_description": "För att få ut det mesta av Vocalise, börja med att berätta lite om dig själv så att vi kan hjälpa dig att lyckas.",
    "step_1_cta": "Kom igång",
    "voice_type": "Rösttyp",
    "exercise_frequency": "Hur många gånger i veckan vill du öva?",
    "knowledge_level": "Kunskapsnivå",
    "notes_label": "Något mer du vill lägga till? (Valfritt)",
    "notes_placeholder": "Skriv din text här",
    "step_2_cta": "Slutför introduktion",
    "step_2_cta_next": "Nästa",
    "voice_types": {
      "soprano": "Sopran",
      "mezzo_soprano": "Mezzosopran",
      "alto_contralto": "Alt / Kontraalt",
      "tenor": "Tenor",
      "baritone": "Baryton",
      "bass": "Bas",
      "unknown": "Jag vet inte"
    },
    "knowledge_levels": {
      "beginner": "Nybörjare",
      "intermediate": "Medel",
      "advanced": "Avancerad"
    }
  },
  "voice_assessment": {
    "page_title": "Vocalise Röstmätning",
    "title": "Röstmätning",
    "description": "Varje mätning hjälper till att ge en tydligare bild av din röstutveckling.",
    "what_to_expect_heading": "Vad du kan förvänta dig:",
    "step_1": "En check-in om hur din röst känns",
    "step_2": "Genomför en uppsättning mätningar. Varje mätning följs av en kort reflektion.",
    "step_2_standalone_one": "Genomför en mätning. Följd av en kort reflektion.",
    "step_2_standalone_other": "Genomför {{count}} mätningar. Varje mätning följs av en kort reflektion.",
    "step_3": "En slutlig reflektion över hela mätningen",
    "duration": "Tar ungefär 5 minuter",
    "duration_about": "Tar ungefär {{duration}}",
    "later_quiet_title": "Gör den när du är redo",
    "later_quiet_note": "Du behöver inte göra detta nu. Hoppa över och kom tillbaka när du har tid och befinner dig i en tyst miljö.",
    "start_cta": "Starta röstmätning",
    "skip_cta": "Inte nu",
    "skip_header": "Avsluta",
    "header_measurement_recording": "Mätning {{current}}: Inspelning",
    "header_measurement_questions": "Mätning {{current}}: Frågor",
    "header_named_measurement_recording": "{{name}}: Inspelning",
    "header_named_measurement_questions": "{{name}}: Frågor",
    "header_reflection": "Reflektion",
    "measurement_recording_title": "Mätning {{current}} av {{total}}",
    "recording_instructions_title": "Gör dig redo att spela in",
    "recording_instructions": {
      "quiet_environment": "Se till att du befinner dig i en tyst miljö för bästa resultat",
      "posture": "Stå bekvämt med lätt mjuka knän och slappna av i axlarna",
      "breath": "Ta ett djupt andetag innan du börjar",
      "voice": "Sjung med i övningen. Fortsätt tills det börjar kännas ansträngande, men aldrig smärtsamt",
      "listen": "Lyssna på melodin en gång, och sjung sedan med till pianot"
    },
    "recording_instructions_cta": "Jag förstår!",
    "complete_assessment_cta": "Slutför mätningen",
    "leave_session_title": "Lämna röstmätningen?",
    "leave_session_message": "Du kommer inte att kunna fortsätta den här röstmätningen efter att du lämnat den.",
    "leave_session_continue": "Fortsätt röstmätningen",
    "leave_session_leave": "Lämna",
    "finish_heading": "Bra gjort {{name}}.",
    "finish_subheading": "Röstmätningen är klar!",
    "upload_failed_title": "Uppladdning av röstmätning misslyckades",
    "upload_failed_message": "Tryck på Försök igen för att skicka igen.",
    "upload_missing_recordings_message": "Vi hittade inte dina inspelningar. Gå tillbaka och bekräfta varje inspelning innan du slutför.",
    "load_definition_failed_title": "Röstmätningen är inte tillgänglig",
    "load_definition_failed_message": "Vi kunde inte ladda mätningen. Kontrollera din anslutning och försök igen.",
    "start_session_failed_message": "Vi kunde inte starta mätningen. Försök igen.",
    "no_measurements_message": "Den här sessionen har inga mätningar konfigurerade.",
    "submit_success_title": "Röstmätning skickad",
    "submit_success_message": "Din inspelning analyseras. Resultat visas under Statistik när de är klara."
  },
  "record": {
    "title": "Spela in din röst",
    "subtitle": "Lyssna på pianot och sjung med",
    "ready_instruction": "Lyssna endast på pianot eller börja spela in och sjung med.",
    "play_piano": "Spela pianonoter",
    "play_example": "Spela exempel",
    "playing_piano": "Spelar pianonoter...",
    "playing_example": "Spelar exempel...",
    "start_recording": "Börja spela in",
    "recording_status": "Spelar in...",
    "elapsed_recording": "Inspelningstid: {{seconds}}s",
    "stop_recording": "Stoppa inspelning",
    "succeeded_status": "Inspelningen lyckades",
    "listen_to_recording": "Lyssna på inspelning",
    "stop_playback": "Stoppa uppspelning",
    "redo_recording": "Spela in igen",
    "quiet_tip": "Se till att du befinner dig i en tyst miljö för bästa resultat.",
    "helper_action_failed": "Vi kunde inte spela upp ljudhjälpen. Försök igen.",
    "piano_helper_action_failed": "Vi kunde inte spela upp pianonoterna. Försök igen.",
    "example_helper_action_failed": "Vi kunde inte spela upp exempelljudet. Försök igen.",
    "retry_helper_action": "Försök igen",
    "permission_required": "Mikrofonbehörighet krävs för att spela in din röst.",
    "start_recording_failed": "Kunde inte starta inspelningen. Försök igen.",
    "stop_recording_failed": "Kunde inte stoppa inspelningen. Försök igen.",
    "playback_failed": "Kunde inte spela upp din inspelning. Försök igen."
  },
  "reflection": {
    "tension_location_instruction": "Välj alla alternativ som passar",
    "personal_reflection_title": "Personlig reflektion",
    "personal_reflection_prompt": "Reflektera över vad du upplevde under övningen. Vad märkte du? Vad kändes bra eller utmanande? Några insikter eller frågor?"
  },
  "check_in": {
    "next_cta": "Nästa"
  }
}
